import { routePaths } from '../../routePaths';
import { translate } from '../../utils';
import { BackofficePermission } from '../../generated/graphql';
import { RouteType } from '../../types';
import { EmployeeIcon } from '../../ui-kit';
import EmployeeListView from './EmployeeListView';
import EmployeeRegisterView from './EmployeeRegisterView';
import EmployeeUpdateView from './EmployeeUpdateView';

const EmployeeRoute: RouteType = {
    exact: true,
    path: routePaths.employee,
    icon: EmployeeIcon,
    title: translate('Employee'),
    component: EmployeeListView,
    permissions: {
        backoffice: [BackofficePermission.HasAccess]
    },
    childrenRoutes: [
        {
            exact: true,
            path: routePaths.employeeCreate,
            title: translate('Create Member'),
            component: EmployeeRegisterView,
        },
        {
            exact: true,
            path: routePaths.employeeUpdate,
            title: translate('Update Member'),
            component: EmployeeUpdateView,
        },
    ]
};

export default EmployeeRoute;
